import { Result, failure, success } from '../shared'
import { ReportingProvider } from './reporting.provider'
import {
  ViewCollmanServerData,
  AddToFavouritesParams,
  RemoveFromFavouritesParams,
  GenerateParams,
  ReportsViewParams,
  ReportsViewServerData,
  ReportsServiceErrorCode,
  ReportsFailure,
  ReportingTypes,
  PrintReportingParams,
} from './reporting.types'

export class ReportingService {
  constructor(private provider: ReportingProvider) {}

  public async view(): Promise<Result<unknown, ReportsFailure>> {
    try {
      const { data } = await this.provider.view()
      return success(data)
    } catch (error) {
      return failure(ReportsServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async viewCollman(): Promise<Result<ViewCollmanServerData, ReportsFailure>> {
    try {
      const { data } = await this.provider.viewCollman()
      return success(data)
    } catch (error) {
      return failure(ReportsServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }
  public async viewLoan(): Promise<Result<unknown, ReportsFailure>> {
    try {
      const { data } = await this.provider.viewLoan()
      return success(data)
    } catch (error) {
      return failure(ReportsServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }
  public async viewApplication(): Promise<Result<unknown, ReportsFailure>> {
    try {
      const { data } = await this.provider.viewApplication()
      return success(data)
    } catch (error) {
      return failure(ReportsServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }
  public async viewCollateral(): Promise<Result<unknown, ReportsFailure>> {
    try {
      const { data } = await this.provider.viewCollateral()
      return success(data)
    } catch (error) {
      return failure(ReportsServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }
  public async viewClient(): Promise<Result<unknown, ReportsFailure>> {
    try {
      const { data } = await this.provider.viewClient()
      return success(data)
    } catch (error) {
      return failure(ReportsServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async printReporting(params: PrintReportingParams): Promise<Result<unknown, ReportsFailure>> {
    try {
      const { data } = await this.provider.printReport(params)
      return success(data)
    } catch (error) {
      return failure(ReportsServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async addToFavourites(params: AddToFavouritesParams): Promise<Result<void, ReportsFailure>> {
    try {
      await this.provider.addToFavourites(params)
      return success()
    } catch (error) {
      return failure(ReportsServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async removeFromFavourites(params: RemoveFromFavouritesParams): Promise<Result<void, ReportsFailure>> {
    try {
      await this.provider.removeFromFavourites(params)
      return success()
    } catch (error) {
      return failure(ReportsServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async generate<T extends ReportingTypes>(params: GenerateParams<T>): Promise<Result<any, ReportsFailure>> {
    try {
      const { data } = await this.provider.generate(params)
      return success(data)
    } catch (error) {
      return failure(ReportsServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async reportsView(params: ReportsViewParams): Promise<Result<ReportsViewServerData, ReportsFailure>> {
    try {
      const { data } = await this.provider.reportsView(params)
      return success(data)
    } catch (error) {
      return failure(ReportsServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }
}
